import request from '@/utils/request'

const baseUrl = '/erp/guide-price'

export const listGuidePrice = (skuId, warehouseId) => request({
  url: baseUrl + '/list', method: 'get', params: { skuId, warehouseId }
})
export const listGuidePriceBySystem = params => request({
  url: baseUrl + '/system-list', method: 'get', params
})
export const saveGuidePrice = data => request({ url: baseUrl + '/save', method: 'post', data })
export const batchSaveGuidePrice = data => request({ url: baseUrl + '/batch-save', method: 'post', data })
export const previewGuidePriceRecalculation = data => request({
  url: baseUrl + '/recalculate-preview', method: 'post', data
})
export const listGuidePriceHistory = guidePriceId => request({
  url: baseUrl + '/history', method: 'get', params: { guidePriceId }
})
export const setGuidePriceEnabled = (id, enabled) => request({
  url: baseUrl + '/status', method: 'post', data: { id, enabled }
})
export const deleteGuidePriceWarehouse = data => request({
  url: baseUrl + '/warehouse/delete', method: 'post', data
})

export const deleteGuidePrice = id => request({
  url: baseUrl + '/delete', method: 'post', data: { id }
})

export const addGuidePriceWarehouse = data => request({
  url: baseUrl + '/warehouse/add', method: 'post', data
})

export const updateGuidePricePurchasePrice = data => request({
  url: baseUrl + '/latest-purchase-price', method: 'post', data
})

export const listSkuPriceRules = skuId => request({
  url: baseUrl + '/sku-rule/list', method: 'get', params: { skuId }
})

export const saveSkuPriceRules = data => request({
  url: baseUrl + '/sku-rule/save', method: 'post', data
})
